var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPercent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6788 8.3335L8.34546 31.6668",
    stroke: "white",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8456 14.9998C13.1468 14.9998 15.0123 13.1344 15.0123 10.8332C15.0123 8.53198 13.1468 6.6665 10.8456 6.6665C8.54444 6.6665 6.67896 8.53198 6.67896 10.8332C6.67896 13.1344 8.54444 14.9998 10.8456 14.9998Z",
    stroke: "white",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1789 33.3333C31.4801 33.3333 33.3455 31.4679 33.3455 29.1667C33.3455 26.8655 31.4801 25 29.1789 25C26.8777 25 25.0122 26.8655 25.0122 29.1667C25.0122 31.4679 26.8777 33.3333 29.1789 33.3333Z",
    stroke: "white",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPercent);
export default __webpack_public_path__ + "static/media/icon_percent.12f1491fcfb3cbe0a1dec9e34431104c.svg";
export { ForwardRef as ReactComponent };